import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "@services/auth.service";
import { CourseService } from "@services/course.service";


@Injectable({
  providedIn: 'root'
})

export class AdminAuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {


  constructor(private authService: AuthService, private courseService: CourseService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //Start Custom Route Guard
      if (!this.authService.loggedIn()) {
        this.router.navigate(['login']);
      }
      let url: string = state.url;
      return this.checkUserLogin(next, url);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
    if (this.authService.loggedIn()) {
      const userRole = this.authService.getRole();
      
      // Handle null role (invalid/expired token)
      if (!userRole) {
        console.warn('No valid role found in token');
        this.router.navigate(['/login']);
        return false;
      }

      // Check if route requires specific roles
      if (route.data['role']) {
        const requiredRoles = Array.isArray(route.data['role']) ? route.data['role'] : [route.data['role']];
        
        if (requiredRoles.indexOf(userRole) === -1) {
          console.warn(`Access denied. User role: ${userRole}, Required roles: ${requiredRoles.join(', ')}`);
          this.router.navigate(['/unauthorized']);
          return false;
        }
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }


}